import { createSlice } from '@reduxjs/toolkit';

export const cookies = createSlice({
  name: 'COOKIES',
  initialState: {}, // declare in store, not here as it will be over written by store

  reducers: {
    setParentPageCookies(state, action) {
      const { parentPageCookies } = action.payload;
      return {
        ...state,
        parentPageCookies: {
          ...state.parentPageCookies,
          ...parentPageCookies,
        },
      };
    },
  },
});

const { actions, reducer } = cookies;

export const { setParentPageCookies } = actions;

export default reducer;
